import { useMemo, cloneElement, ReactElement } from 'react';
import { splitGamesIntoUnits } from './grid-utils';
import { GridsContainer, Grid, CardContainer } from './grid.styles';
import { jackpotGridEnum, jackpotCardSizes } from '~/components/casino-shared/subnavigation/constants';

type JackpotGridMultiplePoolProps = {
	allowIncompleteUnits?: boolean;
	JackpotCard: ReactElement<{
		sizeMobile: {
			width: number;
			height: number;
		};
		sizeDesktop: {
			width: number;
			height: number;
		};
		extraStyles?: Record<string, string>;
	}>;
};

const cardSizes = {
	small: {
		widthMobile: '104px',
		widthDesktop: '162px',
		heightMobile: '104px',
		heightDesktop: '162px'
	}
};

const gridSizes = {
	widthMobile: '220px',
	widthDesktop: '336px',
	heightMobile: '220px',
	heightDesktop: '336px'
};

const JackpotGridMultiplePool = <T extends ReactElement<unknown>[]>({
	JackpotCard,
	GameCards,
	allowIncompleteUnits = false
}: { GameCards: T } & JackpotGridMultiplePoolProps) => {
	const itemsPerUnit = 4;

	const units = useMemo(
		() => splitGamesIntoUnits(GameCards, itemsPerUnit, allowIncompleteUnits),
		[GameCards, itemsPerUnit, allowIncompleteUnits]
	);

	const jackpotCardSize = jackpotCardSizes[jackpotGridEnum.MULTIPLE_POOL];

	return (
		<GridsContainer>
			{cloneElement(JackpotCard, {
				sizeMobile: jackpotCardSize.small,
				sizeDesktop: jackpotCardSize.large,
				extraStyles: {
					marginRight: '12px'
				}
			})}
			{units.map((cards, unitIndex) => (
				<Grid
					// eslint-disable-next-line react/no-array-index-key
					key={`unit-${unitIndex}`}
					widthMobile={gridSizes.widthMobile}
					widthDesktop={gridSizes.widthDesktop}
					heightMobile={gridSizes.heightMobile}
					heightDesktop={gridSizes.heightDesktop}
					extraStylesMobile={{
						gridTemplateColumns: `repeat(auto-fill, ${cardSizes.small.widthMobile})`,
						gridTemplateRows: `repeat(2, ${cardSizes.small.heightDesktop})`,
						gridAutoFlow: 'column'
					}}
					extraStylesDesktop={{
						gridTemplateColumns: `repeat(auto-fill, ${cardSizes.small.widthDesktop})`,
						gridTemplateRows: `repeat(2, ${cardSizes.small.heightDesktop})`,
						gridAutoFlow: 'column'
					}}
				>
					{cards.map(card => (
						<CardContainer key={card.key} size={cardSizes.small}>
							{card}
						</CardContainer>
					))}
				</Grid>
			))}
		</GridsContainer>
	);
};

export default JackpotGridMultiplePool;
